<template>
    <div class="row">
        <div class="col-lg-12 mb-3">
            <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
            <b-card class="mb-2 bg-default-card" :header="$t('general.administrative.daily_logs.title')" header-tag="h3">
                <data-table
                    v-if="tableLoaded"
                    :exportable="this.$store.getters.hasPermission(['project_daily_log'], ['read'])" title=""
                    :rows="getData.rowData"
                    :columns="columndata"
                    :perPage="perPage"
                    :rowsCount="rowsCount"
                    :currentPage="currentPage"
                    :pageCount="pageCount"
                    @exportButtonClick="onExportButton"
                    @rowClickEdit="onEditRow"
                    @rowClickDelete="onDeleteRow"
                    @rowCloneRow="onCloneRow"
                    @rowClickRole="onUserRow"
                    @rowClickPDF="onPDF"
                    @changePage="changePage"
                    @searchEvent="searchEvent"
                    @orderByEvent="orderByEvent"
                    >
                </data-table>

                <button @click="onAddRow" class="btn btn-secondary mt-3" v-if="this.$store.getters.hasPermission(['project_daily_log'], ['create'])"><i class="fa fa-plus-circle"></i> {{$t('general.administrative.daily_logs.create_button')}}</button>
            </b-card>

            <div class="row mt-4">
                <div class="col-sm-12">
                    <span v-if="this.$store.getters.hasPermission(['project_daily_log'], ['create']) && getData.rowData.length > 0">
                        <i class="fa fa-2x fa-clone text-default"></i> - {{$t('general.buttons.clone')}}
                    </span>
                    
                    <span v-if="this.$store.getters.hasPermission(['project_daily_log'], ['read']) && getData.rowData.length > 0">
                        <i class="fa fa-2x fa-user text-info ml-2"></i> - {{$t('general.buttons.roles')}}
                    </span>
                </div>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="saveModal" :title="actionTitle" size="lg" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_daily_log'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.discipline') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedDiscipline"
                                :options="currentDiscipline"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isDisciplineLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onDisciplineSearch"
                                @input="updateDiscipline"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedDiscipline != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedDiscipline"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.company') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedCompany"
                                :options="currentCompany"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isCompanyLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onCompanySearch"
                                @input="updateCompany"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedCompany != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedCompany"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.final_client') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedFinalClient"
                                :options="currentFinalClient"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isFinalClientLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onFinalClientSearch"
                                @input="updateFinalClient"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedFinalClient != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedFinalClient"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.site_manager') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedSiteManager"
                                :options="currentSiteManager"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isSiteManagerLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onSiteManagerSearch"
                                @input="updateSiteManager"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedSiteManager != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedSiteManager"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.date_of_report') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" v-model="model.date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.weather') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.weather">
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.location') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" placeholder="" v-model="model.location">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.order_no') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" placeholder="" v-model="model.order_no">
                        </div>
                    </div>
                    
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.working_hours_day') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==2) return false;" class="form-control" placeholder="" v-model="model.working_hours_day">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-6">
                            <label>{{ $t('table.signature_1') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <toggle-button v-model="model.signature_id_1" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColor1"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-6">
                            <label>{{ $t('table.signature_2') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <toggle-button v-model="model.signature_id_2" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColor2"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-6">
                            <label>{{ $t('table.signature_3') }}</label>
                        </div>
                        <div class="col-lg-6">
                            <toggle-button v-model="model.signature_id_3" :sync="true" :width="100" :value="false" :labels="{checked: $t('misc.signed'), unchecked: $t('misc.not_signed')}" :color="toggleColor3"/>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label>{{ $t('table.notes') }}</label>
                            <textarea class="form-control" maxlength="5000" v-model="model.notes" rows="5"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label>{{ $t('table.safety') }}</label>
                            <textarea class="form-control" maxlength="5000" v-model="model.safety_log_description" rows="5"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label>{{ $t('table.daily_report') }}</label>
                            <textarea class="form-control" maxlength="5000" v-model="model.daily_report_log_description" rows="5"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label>{{ $t('table.special_occurences') }}</label>
                            <textarea class="form-control" maxlength="5000" v-model="model.special_occurences_log_description" rows="5"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label>{{ $t('table.schedule') }}</label>
                            <textarea class="form-control" maxlength="5000" v-model="model.schedule_log_description" rows="5"></textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="model.company_id != null && model.clone_id == null">
                <hr>

                <h3>{{ $t('table.add_roles') }}</h3>
                <div class="row">
                    <div class="col-lg-12">
                        <b-card no-body class="mb-3 mt-3" v-for="(field, idx) in users" :key="idx">
                            <b-card-body class="row">
                                <div class="col-lg-12">
                                    <div class="closeBtn">
                                        <i class="fa fa-times float-right cursor-pointer" @click="deleteCard(idx)"></i>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-8">
                                            <multiselect 
                                                v-model="field.selected"
                                                :options="field.currentUsers"
                                                :multiple="false"
                                                :clear-on-select="true"
                                                :hide-selected="false"
                                                :loading="field.isLoading"
                                                :preserve-search="true" 
                                                placeholder="" 
                                                label="name" track-by="id" 
                                                :selectLabel="''" 
                                                @search-change="onSelectSearch($event, idx)" 
                                                @input="onSelectUpdate($event, idx)"
                                            >
                                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                                            </multiselect>
                                        </div>
                                        
                                        <div class="col-sm-4">
                                            <input type="number" onKeyPress="if(this.value.length==6) return false;" step=".01" class="form-control" :placeholder="$t('table.count')" v-model="field.count">
                                        </div>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>

                        <plus-button class="p-3" @click.native="addCard">{{ $t('table.add_role_company') }}</plus-button>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>

        <confirm-dialog ref="pdfModal" :title="actionTitlePdf" @buttonClick="onDownloadPDF">
            <p class="m-0">{{ $t('messages.download_pdf') }}</p>
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import http from '@/libs/http';
import flatPickr from 'vue-flatpickr-component';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import miniToastr from 'mini-toastr';
import Multiselect from 'vue-multiselect';
import PlusButton from '@/components/global/miscellaneous/PlusButton.vue';
import 'flatpickr/dist/flatpickr.css';

export default {
    name: 'daily_logs',
    components: {
        DataTable,
        ConfirmDialog,
        flatPickr,
        notificationIcons,
        Multiselect,
        PlusButton
    },
    data () {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.administrative.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.administrative.daily_logs.title'),
                    active: true
                }
            ],
            toggleColor1: '#5373d4',
            toggleColor2: '#5373d4',
            toggleColor3: '#5373d4',
            isLoading: false,
            tableNameTranslated: Vue.i18n.translate('general.administrative.daily_logs.title_modal'),
            tableName: 'dailylog',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            actionTitlePdf: '',

            selectedDiscipline: null,
            selectedCompany: null,
            selectedFinalClient: null,
            selectedSiteManager: null,
            selectedRole: null,

            currentDiscipline: [],
            currentCompany: [],
            currentFinalClient: [],
            currentSiteManager: [],

            isDisciplineLoading: false,
            isCompanyLoading: false,
            isFinalClientLoading: false,
            isSiteManagerLoading: false,
            selectedUser: null,
            users: [],
            roles: [{
                isLoading: false,
                selected: {},
                currentRoles: []
            }],
            model: {
                clone_id: null,
                role_id: null,
                discipline_id: null,
                company_id: null,
                site_manager_id: null,
                final_client_id: null,
                date: null,
                weather: null,
                location: null,
                order_no: null,
                working_hours_day: null,
                notes: null,
                safety_log: null,
                safety_log_description: null,
                safety_log_obs: null,
                daily_report_log: null,
                daily_report_log_description: null,
                daily_report_log_obs: null,
                special_occurences_log: null,
                special_occurences_log_description: null,
                special_occurences_log_obs: null,
                schedule_log: null,
                schedule_log_description: null,
                schedule_log_obs: null,
            },
            addedRoles: {
                count: ['']
            },
            getData: {
                rowData: [],
            },
            columndata: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '200px',
                    field: '',
                    showCloneButton: true,
                    showDeleteButton: true,
                    showEditButton: true,
                    showRolesButton: true,
                    showPDF: true,
                },
                {
                    label: Vue.i18n.translate('table.discipline'),
                    field: 'discipline.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.company'),
                    field: 'company.name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.date_of_report'),
                    width: '140px',
                    field: 'date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.location'),
                    field: 'location',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.order_no'),
                    field: 'order_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.site_manager'),
                    width: '140px',
                    field: 'site_manager.fullname',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.weather'),
                    field: 'weather',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.working_hours_day'),
                    field: 'working_hours_day',
                    numeric: false,
                    html: false,
                }
            ]
        }
    },
    mounted () {
        this.onLoadTable();
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        clearSearches () {
            this.currentDiscipline  = [];
            this.currentCompany     = [];
            this.currentFinalClient = [];
            this.currentSiteManager = [];

            this.selectedDiscipline  = null;
            this.selectedCompany     = null;
            this.selectedFinalClient = null;
            this.selectedSiteManager = null;

            this.selectedRole = null;
            this.currentRoles = [];
        },
        onCloneRow (rowClone) {
            this.actionTitle = Vue.i18n.translate('modal.general.clone') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();
            this.model.clone_id                           = rowClone.id,
            this.model.date                               = rowClone.date;
            this.model.weather                            = rowClone.weather;
            this.model.location                           = rowClone.location;
            this.model.order_no                           = rowClone.order_no;
            this.model.working_hours_day                  = rowClone.working_hours_day;
            this.model.notes                              = rowClone.notes;
            this.model.safety_log_description             = rowClone.safety_log_description;
            this.model.daily_report_log_description       = rowClone.daily_report_log_description
            this.model.special_occurences_log_description = rowClone.special_occurences_log_description;
            this.model.schedule_log_description           = rowClone.schedule_log_description;
            this.model.discipline_id                      = rowClone.discipline_id;
            this.model.company_id                         = rowClone.company_id;
            this.model.site_manager_id                    = rowClone.site_manager_id;
            this.model.final_client_id                    = rowClone.final_client_id;
            this.selectedDiscipline                       = rowClone.discipline;
            this.selectedCompany                          = rowClone.company;
            this.selectedFinalClient                      = rowClone.final_client;
            this.selectedSiteManager                      = rowClone.site_manager;
            this.toggleColor1                             = '#5373d4';
            this.toggleColor2                             = '#5373d4';
            this.toggleColor3                             = '#5373d4';
            this.model.signature_id_1                     = null;
            this.model.signature_id_2                     = null;
            this.model.signature_id_3                     = null;
            this.$refs.saveModal.show();
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.clearSearches();
            this.row = null;
            this.toggleColor1                             = '#5373d4';
            this.toggleColor2                             = '#5373d4';
            this.toggleColor3                             = '#5373d4';
            this.model.clone_id                           = null;
            this.model.signature_id_1                     = null;
            this.model.signature_id_2                     = null;
            this.model.signature_id_3                     = null;
            this.model.discipline_id                      = null;
            this.model.company_id                         = null;
            this.model.site_manager_id                    = null;
            this.model.final_client_id                    = null;
            this.model.date                               = null;
            this.model.weather                            = null;
            this.model.location                           = null;
            this.model.order_no                           = null;
            this.model.working_hours_day                  = null;
            this.model.notes                              = null;
            this.model.safety_log_description             = null;
            this.model.daily_report_log_description       = null;
            this.model.special_occurences_log_description = null;
            this.model.schedule_log_description           = null;
            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.users = [];
            this.toggleColor1                             = ((this.$store.state.user.user.id == this.row.signature_id_1) || this.row.signature_id_1 == null) ? '#5373d4' : '#75C791';
            this.toggleColor2                             = ((this.$store.state.user.user.id == this.row.signature_id_2) || this.row.signature_id_2 == null) ? '#5373d4' : '#75C791';
            this.toggleColor3                             = ((this.$store.state.user.user.id == this.row.signature_id_3) || this.row.signature_id_3 == null) ? '#5373d4' : '#75C791';
            this.model.clone_id                           = null;
            this.model.date                               = this.row.date;
            this.model.weather                            = this.row.weather;
            this.model.location                           = this.row.location;
            this.model.order_no                           = this.row.order_no;
            this.model.working_hours_day                  = this.row.working_hours_day;
            this.model.notes                              = this.row.notes;
            this.model.safety_log_description             = this.row.safety_log_description;
            this.model.daily_report_log_description       = this.row.daily_report_log_description
            this.model.special_occurences_log_description = this.row.special_occurences_log_description;
            this.model.schedule_log_description           = this.row.schedule_log_description;
            this.model.discipline_id                      = this.row.discipline_id;
            this.model.company_id                         = this.row.company_id;
            this.model.site_manager_id                    = this.row.site_manager_id;
            this.model.final_client_id                    = this.row.final_client_id;
            this.selectedDiscipline                       = (typeof this.row.discipline.name != 'undefined' && this.row.discipline.name != '') ? this.row.discipline : null;
            this.selectedCompany                          = (typeof this.row.company.name != 'undefined' && this.row.company.name != '') ? this.row.company : null;
            this.selectedFinalClient                      = this.row.final_client;
            this.selectedSiteManager                      = (typeof this.row.site_manager.fullname != 'undefined' && this.row.site_manager.fullname != '') ? this.row.site_manager : null;
            this.model.signature_id_1                     = Boolean(this.row.signature_id_1);
            this.model.signature_id_2                     = Boolean(this.row.signature_id_2);
            this.model.signature_id_3                     = Boolean(this.row.signature_id_3);
            this.$refs.saveModal.show();
        },
        onDeleteRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        onUserRow(row) {
            this.$store.commit('SET_BACKDATA', row.company_id);
            this.$router.push({name: 'daily_logs_users', params: {id: this.$route.params.id, idm: row.id}});
        },
        onLoadTable() {
            let data = http.route(this.tableName + '?project_id='+this.$route.params.id+'&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get();
            data.then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (field.discipline == null) {
                            field.discipline = { 
                                'name' : '' 
                            };
                        }

                        if (field.company == null) {
                            field.company = { 
                                'name': '' 
                            };
                        }

                        if (field.site_manager == null) {
                            field.site_manager = { 
                                'fullname': '' 
                            };
                        }
                    });
                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                project_id:                         this.$route.params.id,
                date:                               this.model.date,
                weather:                            this.model.weather,
                location:                           this.model.location,
                order_no:                           this.model.order_no,
                working_hours_day:                  this.model.working_hours_day,
                notes:                              this.model.notes,
                safety_log_description:             this.model.safety_log_description,
                daily_report_log_description:       this.model.daily_report_log_description,
                special_occurences_log_description: this.model.special_occurences_log_description,
                schedule_log_description:           this.model.schedule_log_description,
                discipline_id:                      this.model.discipline_id,
                company_id:                         this.model.company_id,
                site_manager_id:                    this.model.site_manager_id,
                final_client_id:                    this.model.final_client_id,
                signature_id_1:                     this.model.signature_id_1,
                signature_id_2:                     this.model.signature_id_2,
                signature_id_3:                     this.model.signature_id_3,
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            var allRoles = [];
            this.users.forEach(user => {
                if (user.count != null && typeof user.selectedUser.id != 'undefined') {
                    allRoles.push({
                        'count': user.count,
                        'role_id': user.selectedUser.id
                    });
                }
            });

            if (this.row) {
                let data = http.route(this.tableName + '/' + this.row.id).patch(put_data, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.$refs.saveModal.hide();
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        var that = this;
                        if (allRoles.length > 0 && this.model.company_id != null) {
                            let data = http.route('dailylog/' + that.row.id + '/roles').post({
                                roles: allRoles
                            }, true);
                            data.then(res => {
                                if (res.data == false) {
                                    Object.keys(res.errorMessage).forEach(key => {
                                        this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                    });
                                }
                            });
                        }
                    }
                });
            } else {
                if (this.model.clone_id != null) {
                    put_data['clone_id'] = this.model.clone_id;
                }

                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if(response.data == false) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.$refs.saveModal.hide();
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                        var that = this;
                        if (allRoles.length > 0 && this.model.company_id != null) {
                            let data = http.route('dailylog/' + response.data.id + '/roles').post({
                                roles: allRoles
                            }, true);
                            data.then(res => {
                                if (res.data == false) {
                                    Object.keys(res.errorMessage).forEach(key => {
                                        this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                    });
                                }
                            });
                        }
                    }
                });
            }
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if(response.isError) {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    } else {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }
                        
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onSelectUpdate(user, idx) {
            this.users[idx].selectedUser = user;
        },
        onPDF (row) {
            this.actionTitlePdf = Vue.i18n.translate('modal.general.download_pdf');
            this.row = row;
            this.$refs.pdfModal.show();
        },
        onDownloadPDF (button) {
            if(button == 1) {
                let data = http.route('dailylog/' + this.row.id).get(
                {
                    export_pdf: 1
                }, true);
                data.then(response => {
                    if (!response.isError) {
                        let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                            if (response.data) {
                                miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                            } else {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                                });
                            }
                        });
                    } else {
                        miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                    }
                });
            }
            
            this.$refs.pdfModal.hide();
        },
        addCard () {
            this.users.push({"isLoading": false, "selected": {}, "currentUsers": [], "count": null});
        },
        deleteCard (idx) {
            if (this.users.length > 1) {
                this.users.splice(idx, 1);
            }
        },
        onExportButton() {
            http.route('dailylog?project_id=' + this.$route.params.id).exportExcel({
                export: 1,
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'daily_logs.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onSelectSearch(search, idx) {
            if(this.model.company_id) {
                this.users[idx].isLoading = true;
                this.search(search, this.users[idx], this.model, this);
            }
        },
        search: _.debounce((search, vm, model, that) => {
            if (that.row != null) {
                let data = http.route('roles?get_all=1&filters[company_id]='+model.company_id+'&search_select=' + search+'&filters[not_in_roles]='+that.row.id).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentUsers = response.data;
                    }
                    vm.isLoading = false;
                });
            } else {
                let data = http.route('roles?get_all=1&filters[company_id]='+model.company_id+'&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentUsers = response.data;
                    }
                    vm.isLoading = false;
                });
            }
        }, 500),
        onDisciplineSearch(search) {
            if (search == '') {
                this.currentDiscipline = [];
                
                return false;
            }

            this.isDisciplineLoading = true;
            this.searchDiscipline(search, this);
        },
        searchDiscipline: _.debounce((search, vm) => {
            let data = http.route('discipline?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDiscipline = response.data;
                }
                vm.isDisciplineLoading = false;
            });
        }, 500),
        updateDiscipline(discipline) {
            this.model.discipline_id = (discipline != null) ? discipline.id : null;
        },
        clearSelectedDiscipline () {
            this.selectedDiscipline  = null;
            this.model.discipline_id = null;
        },
        onCompanySearch(search) {
            if (search == '') {
                this.currentCompany = [];
                
                return false;
            }

            this.isCompanyLoading = true;
            this.searchCompany(search, this);
        },
        searchCompany: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentCompany = response.data;
                }
                vm.isCompanyLoading = false;
            });
        }, 500),
        updateCompany(company) {
            this.model.company_id = (company != null) ? company.id : null;
            if (company != null) {
                http.route('roles?filters[company_id]='+company.id).get().then(response => {
                    if (response.data != false) {
                        this.currentUsers = response.data;
                        this.isLoading = false;
                    }
                });
            } else {
                this.currentUsers = [];
                this.users = [];
            }
        },
        clearSelectedCompany () {
            this.selectedCompany  = null;
            this.model.company_id = null;
        },
        onFinalClientSearch(search) {
            if (search == '') {
                this.currentFinalClient = [];
                
                return false;
            }

            this.isFinalClientLoading = true;
            this.searchFinalClient(search, this);
        },
        searchFinalClient: _.debounce((search, vm) => {
            let data = http.route('company?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentFinalClient = response.data;
                }
                vm.isFinalClientLoading = false;
            });
        }, 500),
        updateFinalClient(company) {
            this.model.final_client_id = (company != null) ? company.id : null;
        },
        clearSelectedFinalClient () {
            this.selectedFinalClient   = null;
            this.model.final_client_id = null;
        },
        onSiteManagerSearch(search) {
            if (search == '') {
                this.currentSiteManager = [];
                
                return false;
            }

            this.isSiteManagerLoading = true;
            this.searchSiteManager(search, this);
        },
        searchSiteManager: _.debounce((search, vm) => {
            let data = http.route('user/getall?get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentSiteManager = response.data;
                }
                vm.isSiteManagerLoading = false;
            });
        }, 500),
        updateSiteManager(user) {
            this.model.site_manager_id = (user != null) ? user.id : null;
        },
        clearSelectedSiteManager () {
            this.selectedSiteManager   = null;
            this.model.site_manager_id = null;
        },
        updateRole(role) {
            this.model.role_id = (role != null) ? role.id : null;
        },
    }
}
</script>

<style scoped>
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/pages/project/administrative/daily_logs/daily_logs.vue